<template>
  <div class="card mb-5" style="margin-top:4rem; overflow:visible">
    <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height:60px;">
      <div class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
        <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">
          {{ t('settings.areas.edit') }}
        </h6>
      </div>
    </div>

    <LoadingSpinner v-if="loading" :message="t('common.loading')" />

    <div v-else class="card-body px-0 pb-2 pe-3">
      <div class="row justify-content-center">
        <div class="col-md-8 ms-3">
          <AreaForm ref="form" :initial-data="data" @submit="save" @validation-error="warn" />
          <div class="d-flex gap-3 mt-3">
            <button class="btn btn-primary btn-sm flex-grow-1" :disabled="saving" @click="form?.submit()">
              <span v-if="saving"><i class="fas fa-spinner fa-spin me-2"></i>{{ t('common.saving') }}</span>
              <span v-else><i class="fas fa-save ms-2"></i>{{ t('common.saveChanges') }}</span>
            </button>
            <button class="btn btn-outline-secondary btn-sm flex-grow-1" :disabled="saving" @click="goIndex">
              <i class="fas fa-times ms-2"></i>{{ t('common.cancel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import AreaForm from '@/components/features/areas/AreaForm.vue'
import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import api from '@/api'
import { useI18n } from 'vue-i18n'
import { useToast } from 'vue-toastification'

const { t } = useI18n()
const toast = useToast()
const route = useRoute()
const router = useRouter()

const form = ref(null)
const loading = ref(true)
const saving = ref(false)
const data = ref({ name: '' })

onMounted(async () => {
  try {
    const { data: res } = await api.get(`/areas/${route.params.id}`)
    data.value = { name: res?.data?.name ?? '' }
  } catch (e) {
    toast.error(e.response?.data?.message || t('common.failedLoad'))
    router.push({ name: 'settings.areas.index' })
  } finally {
    loading.value = false
  }
})

const save = async (payload) => {
  saving.value = true
  try {
    await api.put(`/areas/${route.params.id}`, payload)
    toast.success(t('common.updatedSuccessfully'))
    goIndex()
  } catch (e) {
    form.value?.setServerErrors(e.response?.data?.errors || {})
    toast.error(e.response?.data?.message || t('common.updateFailed'))
  } finally {
    saving.value = false
  }
}
const warn = () => toast.warning(t('validation.correctErrors'))
const goIndex = () => router.push({ name: 'settings.areas.index' })
</script>
